<template>
  <!-- 对话框内容 -->
  <el-row>
    <el-row>
      <el-dialog
        title="录入溶剂参数信息"
        :visible.sync="showSolventList"
        :before-close="closeSolventList"
      >
        <el-row>
          <el-col :span="16" :offset="4">
            <el-form :model="SolventListObj" ref="SolventList" :rules="rules">
              <el-table
                :data="SolventListObj.SolventList"
                :border="true"
                :header-cell-style="{
                  background: '#f3f6f9',
                  'text-align': 'center',
                }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column label="溶剂名称">
                  <template slot-scope="scope">
                    <span>{{ solventNo[scope.$index] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="溶剂">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'SolventList.' + scope.$index + '.Solvent'"
                    >
                      <el-select
                        v-model="scope.row.Solvent"
                        style="margin-top: 25px"
                        @change="changeSolvent(scope.$index)"
                      >
                        <el-option
                          v-for="fp in flowPhaseList"
                          :key="fp.id"
                          :label="fp.solvent"
                          :value="fp.solvent"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="百分比">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'SolventList.' + scope.$index + '.Percent'"
                      :rules="rules.Percent"
                    >
                      <el-input
                        oninput="if(!value || value<0)value=0"
                        v-model="scope.row.Percent"
                        type="mini"
                        style="margin-top: 25px"
                        @input="changePercent(scope.$index)"
                      >
                        <div slot="append">%</div>
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 15px">
                <div>备注</div>
                <el-input
                  placeholder="如含有添加剂等，请说明"
                  type="textarea"
                  autosize
                  clearable
                  style="margin-top: 5px"
                  v-model="form.tlc.remark"
                ></el-input>
              </div>
            </el-form>
          </el-col>
        </el-row>
        <el-row style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="finishSolvent">完成</el-button>
        </el-row>
      </el-dialog>
    </el-row>
    <el-row>
      <el-dialog
        title="填写RF参数信息"
        :visible.sync="showRFList"
        :before-close="closeRFList"
      >
        <el-form label-width="60px">
          <el-row v-for="(object, index) in RFList" :key="index">
            <el-col :span="12" :offset="4">
              <el-row
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <el-col :span="20">
                  <el-form-item :label="object.level" prop="Value">
                    <el-input v-model="object.Value" size="mini"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" :offset="2">
                  <el-form-item class="box-check">
                    <input
                      type="checkbox"
                      v-model="object.RFFlag"
                      true-value="1"
                      false-value="0"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <el-row style="text-align: center">
          <el-button type="primary" @click="addRFList">新增</el-button>
          <el-button type="primary" @click="delRFList" v-if="RFList.length > 3"
            >删除</el-button
          >
          <el-button type="primary" @click="finishRFList">完成</el-button>
        </el-row>
      </el-dialog>
    </el-row>
    <el-row>
      <el-dialog
        title="填写RT参数信息"
        :visible.sync="showRTList"
        class="rt-dialog"
        :before-close="closeRTList"
      >
        <el-row>
          <el-col :span="20" :offset="2">
            <el-form label-width="60px">
              <el-table
                :data="RTList"
                style="width: 100%"
                border
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column width="100">
                  <template slot-scope="scope">
                    <span>Rt{{ scope.row.ComponentIndex }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="时间">
                  <template slot-scope="scope">
                    <el-form-item :prop="'RTList.' + scope.$index + '.Time'">
                      <el-input
                        v-model="scope.row.Time"
                        type="mini"
                        style="margin-top: 25px"
                        placeholder="请输入数字"
                      >
                        <div slot="append">min</div>
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="百分比">
                  <template slot-scope="scope">
                    <el-form-item :prop="'RTList.' + scope.$index + '.Percent'">
                      <el-input
                        v-model="scope.row.Percent"
                        type="mini"
                        style="margin-top: 25px"
                        placeholder="请输入整数"
                      >
                        <div slot="append">%</div>
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </el-col>
        </el-row>
        <el-row style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="finishRTList">完成</el-button>
        </el-row>
      </el-dialog>
    </el-row>

    <!-- 正文内容 -->
    <el-row>
      <el-form label-width="130px" :model="form" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="方法: ">
              <el-select v-model="form.type" size="mini" @change="changeType">
                <el-option
                  v-for="item in methodType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type === 0">
          <el-col :span="6">
            <el-form-item label="TLC类型">
              <el-select
                v-model="form.tlc.tlcLabel"
                size="mini"
                @change="updateTlCLabel(form.tlc.tlcLabel)"
              >
                <el-option
                  v-for="item in TLCType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="展开剂信息:">
              <el-button type="primary" size="mini" @click="clickSolventDialog"
                >设置</el-button
              >
              <span
                style="color: red; margin-left: 10px"
                v-if="this.$store.state.showSolvent"
                >请完善展开剂信息</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="正相参数信息:">
              <el-button type="primary" size="mini" @click="showRFList = true"
                >设置</el-button
              >
              <span
                style="color: red; margin-left: 10px"
                v-if="
                  !this.$store.state.rfListOne ||
                  !this.$store.state.rfListTwo ||
                  !this.$store.state.rfListThree
                "
                >请正确输入正相参数信息</span
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type === 0">
          <el-col :span="6">
            <el-form-item label="显色方式:">
              <div style="width: 200px">
                <el-select v-model="form.tlc.tlcColorType" size="mini">
                  <el-option
                    v-for="item in tlcColorOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  v-if="form.tlc.tlcColorType == 0"
                  placeholder="显色方式，限50字"
                  clearable
                  size="mini"
                  style="width: 192px"
                  type="textarea"
                  v-model="form.tlc.tlcColor"
                  maxlength="50"
                  minlength="1"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="TLC图片:">
              <el-upload
                class="upload-demo"
                action="#"
                :limit="1"
                :auto-upload="false"
                list-type="picture"
                :on-change="changeTLCFile"
                :file-list="tlcPngs"
                :on-remove="handleTLCRemove"
                accept=".jpg,.png"
              >
                <el-button type="primary" size="mini">上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type === 1" :gutter="50">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="名称:"
                prop="hplc.flashColumn.analysis_column"
              >
                <el-input
                  v-model="form.hplc.flashColumn.analysis_column"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="流速:" prop="hplc.flashColumn.flow_rate">
                <el-input v-model="form.hplc.flashColumn.flow_rate" size="mini"
                  ><template slot="append">ml/min</template></el-input
                >
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="填料粒径:"
                prop="hplc.flashColumn.particle_diameter"
              >
                <el-input
                  v-model="form.hplc.flashColumn.particle_diameter"
                  size="mini"
                  ><template slot="append">μm</template></el-input
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="内径:"
                prop="hplc.flashColumn.inner_diameter"
              >
                <el-input
                  v-model="form.hplc.flashColumn.inner_diameter"
                  size="mini"
                  ><template slot="append">mm</template></el-input
                >
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="长度:" prop="hplc.flashColumn.length">
                <el-input v-model="form.hplc.flashColumn.length" size="mini"
                  ><template slot="append">mm</template></el-input
                >
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="反相参数信息:">
                <el-button type="primary" size="mini" @click="showRTList = true"
                  >设置</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="流动相A：">
                <el-select
                  v-model="form.hplc.flowA"
                  size="mini"
                  @change="changeFlowA"
                >
                  <el-option
                    v-for="item in FlowPhase"
                    :key="item.id"
                    :label="item.solvent"
                    :value="item.solvent"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="流动相B：">
                <el-select
                  v-model="form.hplc.flowB"
                  size="mini"
                  @change="changeFlowB"
                >
                  <el-option
                    v-for="item in FlowPhase"
                    :key="item.id"
                    :label="item.solvent"
                    :value="item.solvent"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="HPLC图片:">
                <el-upload
                  class="upload-demo"
                  action="#"
                  :limit="1"
                  :auto-upload="false"
                  list-type="picture"
                  :on-change="changeHPLCFile"
                  :file-list="hplcPngs"
                  :on-remove="handleHTLCRemove"
                  accept=".jpg,.png"
                >
                  <el-button type="primary" size="mini">上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
    </el-row>
  </el-row>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "InputOriginMethods",
  data() {
    var flashColumn = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
      } else if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
        if (Math.trunc(value) > 9999) {
          callback(new Error("整数部分不超过四位"));
        } else if (Math.trunc(value) <= 0) {
          callback(new Error("请输入正数"));
        } else {
          callback();
        }
      } else {
        if (Math.trunc(value.toString().split(".")[0]) > 9999) {
          callback(new Error("整数部分不超过四位"));
        } else if (value.toString().split(".")[1] > 99) {
          callback(new Error("小数部分不超过两位"));
        } else if (value.toString().split(".")[0] < 0) {
          callback(new Error("请输入正数"));
        } else {
          callback();
        }
      }
    };

    return {
      rules: {
        Percent: {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback();
            } else if (!Number(value) && Number(value) !== 0) {
              callback(new Error("请输入数字"));
            } else if (Math.trunc(value) < 0) {
              callback(new Error("请输入正数"));
              this.$message("请输入正数");
            } else if (/^[0-9]*[1-9][0-9]*$/.test(Number(value)) == false) {
              this.$message("请输入正整数");
            }
            if (Number(value) > 100) {
              callback(new Error("最大值不能超过100"));
              this.$message("最大值不能超过100");
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      },
      formRules: {
        "hplc.flashColumn.analysis_column": [
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur",
          },
        ],
        "hplc.flashColumn.flow_rate": [
          { validator: flashColumn, trigger: "blur" },
        ],
        "hplc.flashColumn.particle_diameter": [
          { validator: flashColumn, trigger: "blur" },
        ],
        "hplc.flashColumn.inner_diameter": [
          { validator: flashColumn, trigger: "blur" },
        ],
        "hplc.flashColumn.length": [
          { validator: flashColumn, trigger: "blur" },
        ],
      },
      solventNo: ["溶剂A", "溶剂B"],
      flowPhaseList: [],
      username: this.$store.state.username,
      showSolventList: false,
      showGradientDialog: false,
      showRFList: false,
      showRTList: false,
      tlcColorOptions: [
        { value: 1, label: "紫外荧光" },
        { value: 2, label: "磷钼酸" },
        { value: 3, label: "碘粉" },
        { value: 4, label: "香草醛" },
        { value: 5, label: "高锰酸钾" },
        { value: 6, label: "溴甲酚绿" },
        { value: 7, label: "重铬酸盐" },
        { value: 8, label: "硫酸-磷钨酸" },
        { value: 9, label: "茚三酮" },
        { value: 0, label: "其他" },
      ],
      /**
       * 流动相展示
       * */
      form: {
        type: "0",
        tlc: {
          tlc: "", //1: 氧化铝 2:C18
          tlcLabel: "",
          tlcPic: "", //TLC图片
          tlcColor: '',
          tlcColorType: 1,
          remark:''
        },
        hplc: {
          flashColumn: {
            type: "", //1:C18  2:CB  3:硅胶  4:氨基  5:HILIC
            analysis_column: "",
            flow_rate: "",
            particle_diameter: "",
            inner_diameter: "",
            length: "",
          },
          flowPhase: ["", ""], //1: 水  2: 乙腈
          hplcPic: "",
          flowA: "",
          flowB: "",
          hplcflowA: [],
          hplcflowB: [],
        },
      },
      remark: "",
      tlcPngs: [],
      hplcPngs: [],

      //3. TLC展开剂
      SolventListObj: {
        SolventList: [
          {
            Solvent: "",
            Percent: "",
            Polarity: "",
            id: "",
            Density: "",
          },
          {
            Solvent: "",
            Percent: "",
            Polarity: "",
            id: "",
            Density: "",
          },
        ],
      },
      //3. TLC 正相参数列表
      RFList: [
        {
          Value: "",
          RFFlag: 0,
          level: "Rf1",
        },
        {
          Value: "",
          RFFlag: 0,
          level: "Rf2",
        },
        {
          Value: "",
          RFFlag: 0,
          level: "Rf3",
        },
      ],
      // 反相参数列表
      RTList: [
        {
          Area: "",
          ComponentIndex: "",
          TFlag: "",
          Time: "",
          Percent: "",
        },
      ],

      /**
       * 区分分析方法
       * */
      methodType: this.$store.state.sepaMethods.analysisMethodType,
      /**
       * TLC薄层板类别
       * */
      TLCType: this.$store.state.sepaMethods.TLCType,
      /**
       * 色谱柱填料类别
       * */
      columnFillerType: this.$store.state.sepaMethods.columnFillerType,
      FlowPhase: [],
    };
  },
  methods: {
    closeRFList: function () {
      let a = [];
      let b = [];
      let c = [];
      for (let index = 0; index < this.RFList.length; index++) {
        if (
          !Number(this.RFList[index].Value) &&
          Number(this.RFList[index].Value) !== 0
        ) {
          a.push(1);
        }
        if (
          Number(this.RFList[index].Value) >= 1 ||
          Math.trunc(this.RFList[index].Value) < 0
        ) {
          b.push(1);
        }
        if (this.RFList[index].Value.toString().split(".")[1] > 99) {
          c.push(1);
        }
      }
      if (a.length > 0 || b.length > 0 || c.length > 0) {
        this.RFList = [
          {
            Value: "",
            RFFlag: 0,
            level: "Rf1",
          },
          {
            Value: "",
            RFFlag: 0,
            level: "Rf2",
          },
          {
            Value: "",
            RFFlag: 0,
            level: "Rf3",
          },
        ];
        this.showRFList = false;
      } else {
        this.showRFList = false;
      }
    },
    finishRFList() {
      let a = [];
      let b = [];
      let c = [];
      for (let index = 0; index < this.RFList.length; index++) {
        if (
          !Number(this.RFList[index].Value) &&
          Number(this.RFList[index].Value) !== 0
        ) {
          a.push(1);
        }
        if (
          Number(this.RFList[index].Value) >= 1 ||
          Math.trunc(this.RFList[index].Value) < 0
        ) {
          b.push(1);
        }
        if (this.RFList[index].Value.toString().split(".")[1] > 99) {
          c.push(1);
        }
      }
      if (a.length > 0) {
        this.$message("只能输入数字");
      } else if (b.length > 0) {
        this.$message("请输入大于0且小于1的数");
      } else if (c.length > 0) {
        this.$message("小数部分不超过两位");
      } else {
        this.showRFList = false;
      }
    },
    addRFList() {
      console.log(this.RFList.length);
      let levelNew = this.RFList.length + 1;
      this.RFList.push({
        Value: "",
        RFFlag: 0,
        level: `Rf${levelNew}`,
      });
    },
    delRFList: function () {
      if (this.RFList.length > 1) {
        this.RFList.pop();
      }
    },
    closeRTList: function () {
      let rtList = [];
      let rtPer = [];
      let data = [];
      let data3 = [];
      let data2 = [];
      for (let index = 0; index < this.RTList.length; index++) {
        if (this.RTList[index].Percent != "") {
          if (!Number(this.RTList[index].Percent)) {
            if (Number(this.RTList[index].Percent) !== 0) {
              this.$message("只能输入数字");
              this.RTList = [
                {
                  Area: "",
                  ComponentIndex: 1,
                  TFlag: "",
                  Time: "",
                  Percent: "",
                },
                {
                  Area: "",
                  ComponentIndex: 2,
                  TFlag: "",
                  Time: "",
                  Percent: "",
                },
                {
                  Area: "",
                  ComponentIndex: 3,
                  TFlag: "",
                  Time: "",
                  Percent: "",
                },
              ];
              this.showRTList = false;
              return;
            } else {
              rtList.push(this.RTList[index].Percent);
            }
          } else {
            rtList.push(this.RTList[index].Percent);
            rtPer.push(Number(this.RTList[index].Percent));
          }
        }
        if (this.RTList[index].Time != "") {
          if (!Number(this.RTList[index].Time)) {
            if (Number(this.RTList[index].Time) !== 0) {
              this.$message("只能输入数字");
              this.RTList = [
                {
                  Area: "",
                  ComponentIndex: 1,
                  TFlag: "",
                  Time: "",
                  Percent: "",
                },
                {
                  Area: "",
                  ComponentIndex: 2,
                  TFlag: "",
                  Time: "",
                  Percent: "",
                },
                {
                  Area: "",
                  ComponentIndex: 3,
                  TFlag: "",
                  Time: "",
                  Percent: "",
                },
              ];
              this.showRTList = false;
              return;
            } else {
              rtList.push(this.RTList[index].Time);
            }
          } else {
            rtList.push(this.RTList[index].Time);
          }
        }
        if (this.RTList[index].Percent != "" && this.RTList[index].Time != "") {
          data.push({
            No: index,
            Percent: this.RTList[index].Percent,
            Time: this.RTList[index].Time,
          });
        }
        if (this.RTList[index].Percent == "" && this.RTList[index].Time != "") {
          data2.push(2);
        }
      }
      const hasNegativeNumber = rtList.filter((num) => num < 0).length > 0;
      const hasNumber = rtPer.filter((num) => num > 100).length > 0;
      const filterPer = rtPer.filter(
        (num) => typeof num === "number" && num % 1 !== 0
      );
      const filteredArr = rtList.filter((num) => {
        const regex = /\.\d{2,}/;
        return regex.test(num.toString());
      });
      if (hasNegativeNumber) {
        this.$message("请输入大于0的数");
        this.RTList = [
          {
            Area: "",
            ComponentIndex: 1,
            TFlag: "",
            Time: "",
            Percent: "",
          },
          {
            Area: "",
            ComponentIndex: 2,
            TFlag: "",
            Time: "",
            Percent: "",
          },
          {
            Area: "",
            ComponentIndex: 3,
            TFlag: "",
            Time: "",
            Percent: "",
          },
        ];
        this.showRTList = false;
      } else if (filteredArr.length > 0) {
        this.$message("小数点最多只能保留一位");
        this.RTList = [
          {
            Area: "",
            ComponentIndex: 1,
            TFlag: "",
            Time: "",
            Percent: "",
          },
          {
            Area: "",
            ComponentIndex: 2,
            TFlag: "",
            Time: "",
            Percent: "",
          },
          {
            Area: "",
            ComponentIndex: 3,
            TFlag: "",
            Time: "",
            Percent: "",
          },
        ];
        this.showRTList = false;
      } else if (filterPer.length > 0) {
        this.$message("百分比请输入整数");
        this.RTList = [
          {
            Area: "",
            ComponentIndex: 1,
            TFlag: "",
            Time: "",
            Percent: "",
          },
          {
            Area: "",
            ComponentIndex: 2,
            TFlag: "",
            Time: "",
            Percent: "",
          },
          {
            Area: "",
            ComponentIndex: 3,
            TFlag: "",
            Time: "",
            Percent: "",
          },
        ];
        this.showRTList = false;
      } else if (hasNumber) {
        this.$message("百分比不能大于100");
        this.RTList = [
          {
            Area: "",
            ComponentIndex: 1,
            TFlag: "",
            Time: "",
            Percent: "",
          },
          {
            Area: "",
            ComponentIndex: 2,
            TFlag: "",
            Time: "",
            Percent: "",
          },
          {
            Area: "",
            ComponentIndex: 3,
            TFlag: "",
            Time: "",
            Percent: "",
          },
        ];
        this.showRTList = false;
      } else {
        if (rtList.length == 0) {
          this.showRTList = false;
        } else {
          if (rtList.length < 4) {
            this.$message("请填写至少两组数据");
            this.RTList = [
              {
                Area: "",
                ComponentIndex: 1,
                TFlag: "",
                Time: "",
                Percent: "",
              },
              {
                Area: "",
                ComponentIndex: 2,
                TFlag: "",
                Time: "",
                Percent: "",
              },
              {
                Area: "",
                ComponentIndex: 3,
                TFlag: "",
                Time: "",
                Percent: "",
              },
            ];
            this.showRTList = false;
          } else {
            if (data.length == 3) {
              if (
                Number(data[2].Time) > Number(data[1].Time) &&
                Number(data[1].Time) > Number(data[0].Time)
              ) {
                this.showRTList = false;
              } else {
                this.$message("时间不能比前一个小");
                this.RTList = [
                  {
                    Area: "",
                    ComponentIndex: 1,
                    TFlag: "",
                    Time: "",
                    Percent: "",
                  },
                  {
                    Area: "",
                    ComponentIndex: 2,
                    TFlag: "",
                    Time: "",
                    Percent: "",
                  },
                  {
                    Area: "",
                    ComponentIndex: 3,
                    TFlag: "",
                    Time: "",
                    Percent: "",
                  },
                ];
                this.showRTList = false;
              }
            } else {
              for (let index = 0; index < data.length; index++) {
                if (data[index].No == 2) {
                  data3.push(2);
                }
              }
              if (data3.length > 0) {
                this.$message("请完善Rt1和Rt2");
                this.RTList = [
                  {
                    Area: "",
                    ComponentIndex: 1,
                    TFlag: "",
                    Time: "",
                    Percent: "",
                  },
                  {
                    Area: "",
                    ComponentIndex: 2,
                    TFlag: "",
                    Time: "",
                    Percent: "",
                  },
                  {
                    Area: "",
                    ComponentIndex: 3,
                    TFlag: "",
                    Time: "",
                    Percent: "",
                  },
                ];
                this.showRTList = false;
              } else {
                if (data2.length > 0) {
                  this.$message("填写时间后必须填写百分比");
                  this.RTList = [
                    {
                      Area: "",
                      ComponentIndex: 1,
                      TFlag: "",
                      Time: "",
                      Percent: "",
                    },
                    {
                      Area: "",
                      ComponentIndex: 2,
                      TFlag: "",
                      Time: "",
                      Percent: "",
                    },
                    {
                      Area: "",
                      ComponentIndex: 3,
                      TFlag: "",
                      Time: "",
                      Percent: "",
                    },
                  ];
                  this.showRTList = false;
                } else {
                  console.log(data);
                  if (Number(data[1].Time) > Number(data[0].Time)) {
                    this.showRTList = false;
                  } else {
                    this.$message("时间不能比前一个小");
                    this.RTList = [
                      {
                        Area: "",
                        ComponentIndex: 1,
                        TFlag: "",
                        Time: "",
                        Percent: "",
                      },
                      {
                        Area: "",
                        ComponentIndex: 2,
                        TFlag: "",
                        Time: "",
                        Percent: "",
                      },
                      {
                        Area: "",
                        ComponentIndex: 3,
                        TFlag: "",
                        Time: "",
                        Percent: "",
                      },
                    ];
                    this.showRTList = false;
                  }
                }
              }
            }
          }
        }
      }
    },
    finishRTList() {
      let rtList = [];
      let rtPer = [];
      let data = [];
      let data3 = [];
      let data2 = [];
      for (let index = 0; index < this.RTList.length; index++) {
        if (this.RTList[index].Percent != "") {
          if (!Number(this.RTList[index].Percent)) {
            if (Number(this.RTList[index].Percent) !== 0) {
              this.$message("只能输入数字");
              return;
            } else {
              rtList.push(this.RTList[index].Percent);
            }
          } else {
            rtList.push(this.RTList[index].Percent);
            rtPer.push(Number(this.RTList[index].Percent));
          }
        }
        if (this.RTList[index].Time != "") {
          if (!Number(this.RTList[index].Time)) {
            if (Number(this.RTList[index].Time) !== 0) {
              this.$message("只能输入数字");
              return;
            } else {
              rtList.push(this.RTList[index].Time);
            }
          } else {
            rtList.push(this.RTList[index].Time);
          }
        }
        if (this.RTList[index].Percent != "" && this.RTList[index].Time != "") {
          data.push({
            No: index,
            Percent: this.RTList[index].Percent,
            Time: this.RTList[index].Time,
          });
        }
        if (this.RTList[index].Percent == "" && this.RTList[index].Time != "") {
          data2.push(2);
        }
      }
      const hasNegativeNumber = rtList.filter((num) => num < 0).length > 0;
      const hasNumber = rtPer.filter((num) => num > 100).length > 0;
      const filterPer = rtPer.filter(
        (num) => typeof num === "number" && num % 1 !== 0
      );
      const filteredArr = rtList.filter((num) => {
        const regex = /\.\d{2,}/;
        return regex.test(num.toString());
      });
      if (hasNegativeNumber) {
        this.$message("请输入大于0的数");
      } else if (filteredArr.length > 0) {
        this.$message("小数点最多只能保留一位");
      } else if (filterPer.length > 0) {
        this.$message("百分比请输入整数");
      } else if (hasNumber) {
        this.$message("百分比不能大于100");
      } else {
        if (rtList.length == 0) {
          this.showRTList = false;
        } else {
          if (rtList.length < 4) {
            this.$message("请填写至少两组数据");
          } else {
            if (data.length == 3) {
              if (
                Number(data[2].Time) > Number(data[1].Time) &&
                Number(data[1].Time) > Number(data[0].Time)
              ) {
                this.showRTList = false;
              } else {
                this.$message("时间不能比前一个小");
              }
            } else {
              for (let index = 0; index < data.length; index++) {
                if (data[index].No == 2) {
                  data3.push(2);
                }
              }
              if (data3.length > 0) {
                this.$message("请完善Rt1和Rt2");
              } else {
                if (data2.length > 0) {
                  this.$message("填写时间后必须填写百分比");
                } else {
                  console.log(data);
                  if (Number(data[1].Time) > Number(data[0].Time)) {
                    this.showRTList = false;
                  } else {
                    this.$message("时间不能比前一个小");
                  }
                }
              }
            }
          }
        }
      }
    },

    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$store.commit("updateOriginMethods", true);
        } else {
          this.$store.commit("updateOriginMethods", false);
        }
      });
    },
    resetForm() {
      (this.form = {
        type: 0,
        tlc: {
          tlc: "", //1: 氧化铝 2:C18
          tlcLabel: "",
          tlcPic: "", //TLC图片
        },
        hplc: {
          flashColumn: {
            type: "", //1:C18  2:CB  3:硅胶  4:氨基  5:HILIC
            analysis_column: "",
            flow_rate: "",
            particle_diameter: "",
            inner_diameter: "",
            length: "",
          },
          flowPhase: ["", ""], //1: 水  2: 乙腈
          hplcPic: "",
          flowA: "",
          flowB: "",
          hplcflowA: [],
          hplcflowB: [],
        },
      }),
        (this.tlcPngs = []),
        (this.hplcPngs = []),
        //TLC展开剂
        (this.SolventListObj = {
          SolventList: [
            {
              Solvent: "",
              Percent: "",
              Polarity: "",
              id: "",
              Density: "",
            },
            {
              Solvent: "",
              Percent: "",
              Polarity: "",
              id: "",
              Density: "",
            },
          ],
        }),
        //TLC 正相参数列表
        (this.RFList = [
          {
            Value: "",
            RFFlag: 0,
            level: "Rf1",
          },
          {
            Value: "",
            RFFlag: 0,
            level: "Rf2",
          },
          {
            Value: "",
            RFFlag: 0,
            level: "Rf3",
          },
        ]),
        // 反相参数列表
        (this.RTList = [
          {
            Area: "",
            ComponentIndex: "",
            TFlag: "",
            Time: "",
            Percent: "",
          },
        ]);
    },
    submitRFList() {
      this.$refs["RFListOne"].validate((valid) => {
        if (valid) {
          this.$store.commit("RFListOne", true);
        } else {
          this.$store.commit("RFListOne", false);
        }
      });
      this.$refs["RFListTwo"].validate((valid) => {
        if (valid) {
          this.$store.commit("RFListTwo", true);
        } else {
          this.$store.commit("RFListTwo", false);
        }
      });
      this.$refs["RFListThree"].validate((valid) => {
        if (valid) {
          this.$store.commit("RFListThree", true);
        } else {
          this.$store.commit("RFListThree", false);
        }
      });
    },
    changeSolvent(index) {
      this.SolventListObj.SolventList[index].Density = this.flowPhaseList.find(
        (item) =>
          item.solvent === this.SolventListObj.SolventList[index].Solvent
      ).density;
      this.SolventListObj.SolventList[index].Polarity = this.flowPhaseList.find(
        (item) =>
          item.solvent === this.SolventListObj.SolventList[index].Solvent
      ).polarity;
      this.SolventListObj.SolventList[index].id = this.flowPhaseList.find(
        (item) =>
          item.solvent === this.SolventListObj.SolventList[index].Solvent
      ).id;
    },
    changeFlowA() {
      let data = [];
      data.push({
        Solvent: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowA
        ).solvent,
        id: this.FlowPhase.find((item) => item.solvent === this.form.hplc.flowA)
          .id,
        Polarity: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowA
        ).polarity,
        Density: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowA
        ).density,
        eluent_channel: 0,
      });
      this.form.hplc.hplcflowA = data;
    },
    changeFlowB() {
      let data = [];
      data.push({
        Solvent: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowB
        ).solvent,
        id: this.FlowPhase.find((item) => item.solvent === this.form.hplc.flowB)
          .id,
        Polarity: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowB
        ).polarity,
        Density: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowB
        ).density,
        eluent_channel: 1,
      });
      this.form.hplc.hplcflowB = data;
    },
    valueChange() {
      this.$forceUpdate();
    },
    changePercent(index) {
      // console.log(this.SolventListObj.SolventList)
      // // console.log('changePercent',index)
      if (index === 0) {
        this.SolventListObj.SolventList[1].Percent = (
          100 - this.SolventListObj.SolventList[0].Percent
        ).toFixed(0);
      } else {
        this.SolventListObj.SolventList[0].Percent = (
          100 - this.SolventListObj.SolventList[1].Percent
        ).toFixed(0);
      }
    },
    changeType() {
      if (this.form.type === 1) {
        // console.log('type',this.$store.state.flowPhaseList)
        this.flowPhaseList = this.$store.state.flowPhaseList;
        this.form.hplc = {
          flashColumn: {
            type: "", //1:C18  2:CB  3:硅胶  4:氨基  5:HILIC
            analysis_column: "",
            flow_rate: "",
            particle_diameter: "",
            inner_diameter: "",
            length: "",
          },
          flowPhase: ["", ""], //1: 水  2: 乙腈
          hplcPic: "", //hplc图片
        };
      } else if (this.form.type === 0) {
        this.form.tlc = {
          tlc: "", //1: 氧化铝 2:C18
          tlcLabel: "",
          tlcPic: "", //TLC图片
        };
      }
    },
    clickSolventDialog() {
      this.showSolventList = true;
      this.flowPhaseList = this.$store.state.flowPhaseList;
      // this.$store.commit('updateClickSolvent', true)
    },
    finishSolvent() {
      let pers = [];
      for (let i = 0; i < this.SolventListObj.SolventList.length; i++) {
        if (
          this.SolventListObj.SolventList[i].Percent != "" &&
          Number(this.SolventListObj.SolventList[i].Percent > 100)
        ) {
          pers.push(Number(this.SolventListObj.SolventList[i].Percent));
        }
      }
      if (pers.length > 0) {
        this.$message({
          type: "error",
          message: "百分比不能大于100",
        });
      } else {
        this.showSolventList = false;
      }
    },
    closeSolventList() {
      //  this.$refs['SolventList'].resetFields()
      this.showSolventList = false;
    },
    /**
     * 更新TLC的内容
     * */
    updateTlCLabel: function () {
      if (this.form.tlc.tlcLabel == "硅胶") {
        this.form.tlc.tlcLabel = "硅胶";
      }
      if (this.form.tlc.tlcLabel == "C18") {
        this.form.tlc.tlcLabel = "C18";
      }
      if (this.form.tlc.tlcLabel == "氧化铝") {
        this.form.tlc.tlcLabel = "氧化铝";
      }
    },
    /**
     * 图片上传(TLC , HPLC)
     * */
    // getBase64(file) {
    // return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     let imgBase64 = '';
    //     reader.readAsDataURL(file);
    //     reader.onload = () => {
    //     imgBase64 = reader.result;
    //     };
    //     reader.onerror = error => reject(error);
    //     reader.onloadend = () => resolve(imgBase64);
    // });
    // },

    changeTLCFile(file, fileList) {
      this.form.tlc.tlcPic = "";
      fileList.forEach(async (item) => {
        const img = await this.getBase64(item.raw);
        let url = img.substring(img.indexOf(",") + 1).replaceAll(" ", "+");
        this.form.tlc.tlcPic = url;
      });
    },
    handleTLCRemove() {
      this.form.tlc.tlcPic = "";
    },
    changeHPLCFile(file, fileList) {
      this.form.hplc.hplcPic = "";
      fileList.forEach(async (item) => {
        const img = await this.getBase64(item.raw);
        let url = img.substring(img.indexOf(",") + 1).replaceAll(" ", "+");
        this.form.hplc.hplcPic = url;
      });
    },
    handleHTLCRemove() {
      this.form.hplc.hplcPic = "";
    },

    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    readySubmitFile(fileList) {
      //将准备提交的多张图片转为base64
      let _this = this;
      if (!(fileList instanceof Array) || fileList.length <= 0) {
        return false;
      }
      _this.fileMessage.fileNameArr = [];
      _this.fileMessage.fileBase64Arr = [];
      for (let i = 0; i < fileList.length; i++) {
        _this.fileMessage.fileNameArr.push(fileList[i].name);
        _this.getBase64(fileList[i].raw).then(
          (res) => {
            console.log("222", res);
            _this.fileMessage.fileBase64Arr.push(res);
          },
          (err) => {
            console.log(err, "转码失败");
          }
        );
      }
      return true;
    },
    checkRFListType: function () {
      while (this.RFList.length < 3) {
        this.RFList.push({
          Value: "",
          RFFlag: "1",
        });
      }
    },
    checkRTListType: function () {
      while (this.RTList.length < 3) {
        this.RTList.push({
          Area: "",
          ComponentIndex: this.RTList.length + 1,
          TFlag: "",
          Time: "",
          Percent: "",
        });
      }
    },
    // checkHplcFlowPhase: function() {
    //     if(this.form.hplc!=undefined){
    //   while(this.form.hplc.flowPhase.length < 2) {
    //       this.form.hplc.flowPhase.push('')
    //   }
    //     }

    // },
    ...mapActions("sepaMethods", [
      "updateSampleAnalysis",
      "updateRFList",
      "updateRTList",
      "updateSolventList",
    ]),
  },
  created() {
    this.form = this.$store.state.sepaMethods.sampleAnalysis;
    this.RFList = this.$store.state.sepaMethods.RFList;
    this.RTList = this.$store.state.sepaMethods.RTList;
    this.SolventListObj.SolventList = this.$store.state.sepaMethods.SolventList;
    //   this.FlowPhase = this.$store.state.sepaMethods.FlowPhase;
    if (this.form.tlc.tlcPic != "" && this.form.tlc.tlcPic != undefined) {
      this.tlcPngs = [
        {
          name: "TLC图片",
          url: `data:image/png;base64,${this.form.tlc.tlcPic}`,
        },
      ];
    }
    if (this.form.hplc != undefined) {
      if (this.form.hplc.hplcPic != "" && this.form.hplc.hplcPic != undefined) {
        this.hplcPngs = [
          {
            name: "HPLC图片",
            url: `data:image/png;base64,${this.form.hplc.hplcPic}`,
          },
        ];
      }
    }
    this.$api.get("/datacenter/getSolventList ", {}, (res) => {
      if (res.data.code == 200) {
        this.FlowPhase = res.data.data;
        this.$store.commit("updateFlowPhaseList", res.data.data);
      } else {
        this.$message.error("获取溶剂列表失败");
      }
    });
    this.checkRFListType();
    this.checkRTListType();
    //   console.log(this.RTList);
  },
  watch: {
    form: {
      handler() {
        this.updateSampleAnalysis(this.form);
      },
      deep: true,
    },
    RFList: {
      handler() {
        this.updateRFList(this.RFList);
      },
      deep: true,
    },
    RTList: {
      handler() {
        this.updateRTList(this.RTList);
      },
      deep: true,
    },
    SolventList: {
      handler() {
        this.updateSolventList(this.SolventListObj.SolventList);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
@import "../../../assets/position-adjust.css";
.rt-dialog /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.box-check /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>
